import { axiosClient } from "./axiosClient"

export const DASHBOARD_PATH = '/api/v1/dashboard'

export const fetchOrderProfit = (params) => {
    return axiosClient.get(`${DASHBOARD_PATH}/order-profit`, { params: params })
}

export const fetchCustomerProfit = (params) => {
    return axiosClient.get(`${DASHBOARD_PATH}/customer-profit`, { params: params })
}

export const fetchProductProfit = (params) => {
    return axiosClient.get(`${DASHBOARD_PATH}/product-profit`, { params: params })
}
